import { matchVersion } from '../../utils';
import isAndroid from '../os/android';
import __regexp from './__chrome-regexp';
/** Detect Google Chrome Browser version */
export default function isChromeVersion(operator, version) {
	return function (ua) {
		return (
			!isAndroid(ua) &&
			matchVersion({
				ua: ua,
				version: version,
				operator: operator,
				regExp: __regexp,
				groupIndex: 1
			})
		);
	};
}
